import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { stats } from '@/mocks/stats';

const quickLinks = [
  { label: '平台导航', href: '#platforms', icon: 'ri-links-line' },
  { label: '论坛社区', href: '#forums', icon: 'ri-chat-smile-2-line' },
  { label: '发布指南', href: '#guide', icon: 'ri-book-open-line' },
  { label: '常见问题', href: '#faq', icon: 'ri-question-line' },
];

export default function HeroSection() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = keyword.trim();
    navigate(trimmed ? `/directory?q=${encodeURIComponent(trimmed)}` : '/directory');
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20newsroom%20collage%20with%20warm%20cream%20and%20vermilion%20tones%2C%20layered%20folded%20paper%20textures%2C%20sweeping%20soft%20light%20rays%2C%20minimal%20geometric%20network%20lines%20symbolizing%20information%20flow%2C%20artistic%20background%20with%20strong%20contrast%20for%20overlay%20text%2C%20no%20text%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=baoliao-hero-editorial&orientation=landscape"
          alt="爆料信息聚合与流转的抽象艺术背景图"
          title="爆料网上 - 爆料平台导航门户"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/72 to-foreground-950/88"></div>
      </div>

      <div className="relative mx-auto w-full max-w-content px-4 py-16 md:px-6 md:py-24">
        <div className="w-full max-w-3xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs text-background-100 backdrop-blur-sm">
            <span className="inline-flex h-1.5 w-1.5 rounded-full bg-accent-400 animate-soft-pulse"></span>
            186 个可用入口 · 每月核验一次
          </p>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            爆料网上 · 聚合全网
            <span className="text-accent-300">爆料平台</span>
            与论坛社区
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            把分散在各地的爆料网站、论坛与讨论版块按类别整理成一份清晰目录，
            帮你快速定位靠谱的发布入口，少走弯路，不做无效投递。
          </p>

          <form onSubmit={handleSearch} className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
            <div className="relative flex-1">
              <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜平台名称或关键词，例如：消费维权"
                aria-label="搜索爆料平台"
                className="w-full rounded-md border border-background-300 bg-background-50 py-3 pl-10 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              查找入口
            </button>
          </form>

          <div className="mt-7 flex flex-wrap items-center gap-2">
            {quickLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-50/25 px-3.5 py-1.5 text-xs text-background-100 transition-colors hover:border-accent-300 hover:text-accent-300 cursor-pointer"
              >
                <i className={link.icon}></i>
                {link.label}
              </a>
            ))}
            <Link
              to="/contact"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-3.5 py-1.5 text-xs font-medium text-primary-950 transition-colors hover:bg-accent-400 cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>线索投稿
            </Link>
          </div>
        </div>
      </div>

      <div className="relative border-t border-background-50/15 bg-foreground-950/40 backdrop-blur-sm">
        <div className="mx-auto grid max-w-content grid-cols-2 gap-px px-4 md:grid-cols-4 md:px-6">
          {stats.map((item) => (
            <div key={item.label} className="px-1 py-5 md:py-6">
              <p className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">{item.value}</p>
              <p className="mt-1 text-xs font-medium text-background-100 md:text-sm">{item.label}</p>
              <p className="mt-1 text-[11px] leading-relaxed text-background-400 md:text-xs">{item.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}